// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .sidebar-secondary-text {
  font-size: 12px;
}
.presize-root .sidebar-secondary-text .anticon {
  color: #a2a3a8;
}
.presize-root .sidebar-row {
  margin-bottom: 4px;
}
.presize-root .ant-typography.selection-sidebar-title {
  margin-bottom: 0.2em;
}
.presize-root .selection-sidebar.ant-drawer-right.ant-drawer-open .ant-drawer-content-wrapper {
  box-shadow: none;
  border-left: 1px solid #f0f0f0;
}
/*# sourceMappingURL=SelectionSidebar.css.map */`, "",{"version":3,"sources":["webpack://./SelectionSidebar.less","webpack://./src/components/SelectionSidebar/SelectionSidebar.less"],"names":[],"mappings":"AAAA;EAEE,eAAA;ACAF;ADFA;EAII,cAAA;ACCJ;ADLA;EAQE,kBAAA;ACAF;ADRA;EAWE,oBAAA;ACAF;ADXA;EAeI,gBAAA;EACA,8BAAA;ACDJ;AACA,+CAA+C","sourcesContent":[".presize-root { \n .sidebar-secondary-text {\n  font-size: 12px;\n  .anticon {\n    color: #a2a3a8;\n  }\n}\n.sidebar-row {\n  margin-bottom: 4px;\n}\n.ant-typography.selection-sidebar-title {\n  margin-bottom: .2em;\n}\n.selection-sidebar.ant-drawer-right.ant-drawer-open {\n  .ant-drawer-content-wrapper {\n    box-shadow: none;\n    border-left: 1px solid #f0f0f0;\n  }\n}\n \n}",".presize-root .sidebar-secondary-text {\n  font-size: 12px;\n}\n.presize-root .sidebar-secondary-text .anticon {\n  color: #a2a3a8;\n}\n.presize-root .sidebar-row {\n  margin-bottom: 4px;\n}\n.presize-root .ant-typography.selection-sidebar-title {\n  margin-bottom: 0.2em;\n}\n.presize-root .selection-sidebar.ant-drawer-right.ant-drawer-open .ant-drawer-content-wrapper {\n  box-shadow: none;\n  border-left: 1px solid #f0f0f0;\n}\n/*# sourceMappingURL=SelectionSidebar.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
